import React from 'react'
import { Outlet } from 'react-router-dom';
import LandHeader from './layouts/landHeader/LandHeader';
import LandFooter from './layouts/landFooter/landFooter';

const Layout2 = ({setLight, light}) => {
  return (
    <div>
        <LandHeader light={light} setLight={setLight}/>
        <Outlet/>
        <LandFooter light={light} setLight={setLight}/>
    </div>
  )
}

export default Layout2;